import CodePage from "./CodePage";

export default CodePage;
